import(/* webpackMode: "eager" */ "/vercel/path0/components/sign-in-form-otp/sign-in-form-otp.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")